"use strict";

exports.__esModule = true;
exports.getRandomMetricChart = getRandomMetricChart;
exports.getRandomMetricChartRange = getRandomMetricChartRange;
exports.getRandomChart = getRandomChart;
exports.getRandomChartCompare = getRandomChartCompare;
exports.getRandomChartSerie = getRandomChartSerie;

var _moment = _interopRequireDefault(require("moment"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function getRandomMetricChart(metric = "ga:users", range = "7 days") {}

function getRandomMetricChartRange(metric = "ga:users", range = "7 days") {}

function getRandomChart(options) {
  const type = options.type,
        series = options.series,
        yFormat = options.yFormat,
        xFormat = options.xFormat;
  let data = [];

  for (let i = 0; i <= series; i++) {
    const serie = getRandomChartSerie(_extends({}, options, {
      id: i
    }));
    data.push(serie);
  }

  return _extends({}, options, {
    type: type || 'line',
    yFormat: 'date',
    xFormat: xFormat || 'integer',
    data: data
  });
}

function getRandomChartCompare(options) {
  const yFormat = options.yFormat,
        xFormat = options.xFormat;
  const s1 = getRandomChartSerie(_extends({}, options, {
    id: "primary"
  }));
  const s2 = getRandomChartSerie(_extends({}, options, {
    id: "secondary"
  }));
  const data = [s1, s2];
  return _extends({}, options, {
    type: 'line',
    yFormat: 'date',
    xFormat: xFormat || 'integer',
    data: data
  });
}

function getRandomChartSerie(options) {
  const id = options.id,
        date = options.date,
        days = options.days,
        min = options.min,
        max = options.max,
        xFormat = options.xFormat,
        yFormat = options.yFormat;
  let data = [];
  const a = (0, _moment.default)(date);
  const b = (0, _moment.default)(date).add(days, 'days');

  for (var m = (0, _moment.default)(a); m.isBefore(b); m.add(1, 'days')) {
    const x = m.format('YYYY-MM-DD');
    const y = Math.random() * (max - min) + min;
    data.push({
      x: x,
      y: y
    });
  }

  return {
    id: id,
    data: data
  };
}